/**
 * 利用可能なアクセストークンが得られないため、再認証フローを起動する必要があることを示すエラー。
 *
 * UI 層がこのエラーを捕捉して再認証オーバーレイを表示し、ユーザー操作起点で
 * Dialog API を呼び出す責務を持つ。jwtManager (getAccessToken) は popup を直接開かない。
 */
export class ReauthRequiredError extends Error {
    constructor() {
        super("Re-authentication required");
        this.name = "ReauthRequiredError";
    }
}
